import { render, staticRenderFns } from "./TukarUnit.vue?vue&type=template&id=2792910a&scoped=true&"
import script from "./TukarUnit.vue?vue&type=script&lang=ts&"
export * from "./TukarUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2792910a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2792910a')) {
      api.createRecord('2792910a', component.options)
    } else {
      api.reload('2792910a', component.options)
    }
    module.hot.accept("./TukarUnit.vue?vue&type=template&id=2792910a&scoped=true&", function () {
      api.rerender('2792910a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/berita-acara/ba-tukar-unit/TukarUnit.vue"
export default component.exports